/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_CabinsInputs */

const en_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cabins`)
};

const es_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camarotes`)
};

const fr_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cabines`)
};

const de_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabinen`)
};

const ja_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャビン数`)
};

const zh_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客舱`)
};

const ar_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكبائن`)
};

const id_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabin`)
};

const it_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cabine`)
};

const ru_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каюты`)
};

const pt_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cabines`)
};

const ko_field_cabins = /** @type {(inputs: Field_CabinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선실(캐빈)`)
};

/**
* | output |
* | --- |
* | "Cabins" |
*
* @param {Field_CabinsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_cabins = /** @type {((inputs?: Field_CabinsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_CabinsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_cabins(inputs)
	if (locale === "es") return es_field_cabins(inputs)
	if (locale === "fr") return fr_field_cabins(inputs)
	if (locale === "de") return de_field_cabins(inputs)
	if (locale === "ja") return ja_field_cabins(inputs)
	if (locale === "zh") return zh_field_cabins(inputs)
	if (locale === "ar") return ar_field_cabins(inputs)
	if (locale === "id") return id_field_cabins(inputs)
	if (locale === "it") return it_field_cabins(inputs)
	if (locale === "ru") return ru_field_cabins(inputs)
	if (locale === "pt") return pt_field_cabins(inputs)
	return ko_field_cabins(inputs)
});